import { TheMask } from 'vue-the-mask'
import ChangePasswrod from '../../change-password/change-password'
import DatePicker from 'vue2-datepicker'

export default {
  TheMask,
  ChangePasswrod,
  DatePicker
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/account-settings/resources/components.js